import type { IFeigCustomer } from './../../../../libs/types/src/lib/types';
import axios from 'axios';
import { sortBy } from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
import {
  Action,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from 'vuex-module-decorators';
import type { ICustomer, IManagementUser } from '@license-manager/types';
import $http from '../services/api';
import type { FindManyOptions } from 'typeorm';

@Module({ namespaced: true, name: 'feigcompanies' })
export default class FeigCompanies extends VuexModule {
  isLoading = false;
  _companies: IFeigCustomer[] = [];

  @Mutation
  setLoading(loadingState = false) {
    this.isLoading = loadingState;
  }

  @Mutation
  setCompanies(companies) {
    this._companies = companies;
  }

  @Action
  async search(payload = { searchNameOrId: '' }) {
    this.context.commit('setLoading', true);
    const companies = await $http
      .get('feigcustomers/searchByNameOrId', {
        params: { searchNameOrId: payload.searchNameOrId },
      })
      .then((response) => response.data);
    this.context.commit('setLoading', false);
    this.context.commit('setCompanies', companies);
  }

  @Action
  async getByIds({ ids }: { ids: string[] }) {
    return $http
      .get('feigcustomers/' + ids.join(','))
      .then((response) => response.data);
  }

  get companies() {
    return this._companies;
  }
}
